<template>
    <div>
        <ldc-dialog
        title="Đổi mật khẩu"
        :clickoutside="true"
        class="change-password-profile"
        :fullscreen="$detect == 'mobile'"
        width="35%"
        :visible.sync="changePassword">
            <div class="input-password mt-10px">
                <div class="title mb-1">Mật khẩu cũ:</div>
                <input type="password" :class="{
                        'w-100':true,
                        'border-danger': validate.password_old,
                    }"
                    v-model="passwordOld"
                    @focus="validate.password_old = ''"/>
                <div class="validate-form text-danger fs-12px" v-if="validate.password_old">
                    {{ validate.password_old }}
                </div>
            </div>
            <div class="input-password mt-20px">
                <div class="title mb-1">Mật khẩu mới:</div>
                <input type="password" :class="{
                        'w-100':true,
                        'border-danger': validate.password,
                    }"
                    v-model="password"
                    @focus="validate.password = ''"/>
                <div class="validate-form text-danger fs-12px" v-if="validate.password">
                    {{ validate.password }}
                </div>
            </div>
            <div class="input-password mt-20px">
                <div class="title mb-1">Xác nhận mật khẩu:</div>
                <input type="password" :class="{
                        'w-100':true,
                        'border-danger': validate.password_confirmation,
                    }"
                    v-model="passwordConfirmation"
                    @focus="validate.password_confirmation = ''"/>
                <div class="validate-form text-danger fs-12px" v-if="validate.password_confirmation">
                    {{ validate.password_confirmation }}
                </div>
            </div>
            <button class="w-100 btn btn-primary mt-20px py-2" @click="confirmChangePassword()">Xác nhận</button>
        </ldc-dialog>
    </div>
</template>

<script>
import { destroyCookie } from '@/config/token';
export default {
    props: ['active'],
    data() {
        return {
            changePassword: false,
            passwordOld: '',
            password: '',
            passwordConfirmation: '',
            validate: {},
            classValidate: false,
        }
    },
    watch: {
        active(val){
            this.changePassword = val;
        },
        changePassword(val) {
            this.$emit('update:active', val);
        }
    },
    methods: {
        async confirmChangePassword() {
            await this.$confirm(`Bạn có chắc chắn muốn đổi mật khẩu?`,'Đổi mật khẩu', {
                confirmButtonText: 'Đồng ý',
                cancelButtonText: 'Hủy',
                type: 'success'
            }).then(async () => {
                await apiPost('v2/auth/change_password', {
                    password_old: this.passwordOld,
                    password: this.password,
                    password_confirmation: this.passwordConfirmation,
                }).then(res => {
                    if(res.success == 1){
                        this.$message({
                            message: res.message,
                            type: 'success',
                        });
                        this.passwordOld = '';
                        this.password = '';
                        this.passwordConfirmation = '';
                        this.changePassword = false;
                        destroyCookie();
                        location.reload();
                    }
                }).catch(err => {
                    if(err.status == 422) {
                        this.validate = err.data.data;
                    }
                })
            }).catch()
        }
    }
}
</script>

<style lang="scss">
    .change-password-profile {
        .ldc-dialog-content {
            padding-left: 10px !important;
            padding-right: 10px !important;
        }
        .title-dialog {
            background: #007bff;
            color: #fff !important;
            font-size: 16px !important;
            text-align: center;
            padding: 10px 16px;
        }
        .close-modal-mobile {
            position: absolute;
            top: 0;
            font-size: 22px;
            width: 30px;
            height: 30px;
            padding: 3px 0;
            i {
                color: #fff !important;
            }
        }
        .input-password {
            input {
                border: 1px solid rgba(0, 0, 0, 0.2);
                padding: 8px 10px;
                border-radius: 8px;
                &:focus {
                    border: 1px solid #007bff;
                    outline: none !important;
                }
            }
        }
    }
    .profile-web {
        .change-password-profile {
            .close-dialog {
                right: 11px;
                top: 14px;
            }
            .ldc-dialog-content {
                padding: 0 !important;
                border-radius: 10px !important;
            }
            .title-dialog {
                text-align: left;
                background: transparent !important;
                color: #000 !important;
                padding: 20px 20px 10px!important;
                margin-bottom: 0 !important;
                font-weight: 600;
            }
            .main-dialog {
                padding: 0 20px 20px !important;
                button {
                    border-radius: 8px !important;
                }
                .title {
                    color: #666;
                }
            }
        }
    }
</style>
